
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';
import { Speech, SubscriptionName, Voice } from 'types';
import { getVoices } from '@/data/audio_voice';
import { getSubscriptionForEdge } from '@/data/edge';
import { getSpeeches, getTotalSpeechWords } from '@/data/speaches';
import { getProfile } from '@/data/users';
import { SPEECHES_WORDS_IN_PLAN } from '@/constants/common';
import { createClient } from '@/utils/supabase/server-props';
// Both branches are dynamically imported so each visitor only downloads the
// bundle they can actually use — the tool chunk pulls in the full VOICES
// dataset (~1 MB), which public visitors must never pay for. SSR stays on,
// so crawlers still get the fully rendered landing HTML.
const VoiceChangerLanding = dynamic(() => import('@/components/voice-changer/VoiceChangerLanding'));
const VoiceChangerTool = dynamic(() => import('@/components/voice-changer/VoiceChangerTool'));
interface VoiceChangerPageProps {
    isPublic?: boolean;
    initialConversions: Speech[];
    wordsUsed: number;
    wordsLimit: number;
    customVoices: Voice[];
}
const VoiceChangerPage = ({ isPublic, initialConversions, wordsUsed, wordsLimit, customVoices, }: VoiceChangerPageProps) => {
    // Logged-out visitors (and crawlers) get the public landing page; the tool
    // is for authenticated users only.
    if (isPublic) {
        return <VoiceChangerLanding />;
    }
    return (<VoiceChangerTool initialConversions={initialConversions} wordsUsed={wordsUsed} wordsLimit={wordsLimit} customVoices={customVoices}/>);
};
const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
    const supabase = createClient(ctx);
    const { data: { user }, } = await supabase.auth.getUser();
    // Logged-out visitors get the public landing page (indexable — this page
    // used to 302 to /login, which kept it out of search engines entirely).
    if (!user) {
        return {
            props: {
                isPublic: true,
                initialConversions: [],
                wordsUsed: 0,
                wordsLimit: 0,
                customVoices: [],
            },
        };
    }
    const userDetails = await getProfile(user.id);
    const userSubscription = await getSubscriptionForEdge(user.id, userDetails?.team_id);
    const subscriptionName = ((userSubscription &&
        userSubscription?.prices?.products?.name) ||
        'Free') as SubscriptionName;
    const wordsUsed = await getTotalSpeechWords(user.id, userSubscription?.current_period_start as string);
    const wordsLimit = SPEECHES_WORDS_IN_PLAN[subscriptionName] || 0;
    const conversions = await getSpeeches(user.id, false, 20, 'voice_changer');
    // The user's cloned/designed voices, usable as Voice Changer targets. A
    // lookup failure shouldn't take down the page — fall back to presets only.
    const customVoices = await getVoices(user.id).catch(() => []);
    return {
        props: {
            initialConversions: JSON.parse(JSON.stringify(conversions || [])),
            wordsUsed,
            wordsLimit,
            customVoices: JSON.parse(JSON.stringify(customVoices || [])),
        },
    };
};
export default VoiceChangerPage;

    async function __Next_Translate__getServerSideProps__1a167d9f38d__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/voice-changer',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a167d9f38d__ as getServerSideProps }
  